import { useState } from 'react';
import {
    AppBar, Toolbar, Typography, Box, IconButton,
    Card, CardHeader, CardContent, List, ListItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import TicketByPin from './components/TicketByPin';
import TicketByQR from './components/TicketByQR';

function App() {
    const [inProgress, setInProgress] = useState(false);

    const showPopup = (data) => {
        let message = '';
        let title = '';
        if (data?.status === 'success') {
            const ts = data.ticket?.payment?.created_at != null
                ? Math.floor(new Date(data.ticket.payment.created_at).getTime() / 1000)
                : '';
            message = `Подія: "${data.ticket?.tournament?.name}", ${data.ticket?.tournament?.date_formatted}
${data.ticket?.payment?.is_group ? `\nУВАГА: ГРУПОВИЙ КВИТОК! Кількість: ${data.ticket?.payment?.quantity ?? ''} шт.\n` : ''}
Тип: ${data.ticket?.payment?.name ?? ''}
Ціна: ${data.ticket?.payment?.price ?? ''} грн
Код: ${data.ticket?.payment?.coach?.id ?? ''} / ${ts} / ${data.ticket?.number ?? ''}`;
            title = 'Успішно';
        } else {
            message = data.message;
            title = 'Помилка';
        }

        window.Telegram.WebApp.showPopup({
            title,
            message,
            buttons: [
                { id: 'ok', type: 'default', text: 'Зрозуміло' },
            ],
        }, () => {
            setInProgress(false);
        });
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>Квитки</Typography>

                    <TicketByQR showPopup={showPopup} inProgress={inProgress} setInProgress={setInProgress} />
                </Toolbar>
            </AppBar>

              <TicketByPin showPopup={showPopup} setInProgress={setInProgress} />

              <Card sx={{ mt: 2 }}>
                  <CardHeader title="Інструкція з використання" />

                  <CardContent>
                      <List sx={{ listStyle: "decimal", pl: 4 }}>
                          <ListItem sx={{ display: "list-item" }}>
                              Оберіть подію зі списку вище
                          </ListItem>
                          <ListItem sx={{ display: "list-item" }}>
                              Введіть 6-значний PIN з квитка (формат XX-XX-XX) на цифровій клавіатурі
                          </ListItem>
                          <ListItem sx={{ display: "list-item" }}>
                              Натисніть «Додати» — квиток буде перевірено та зафіксовано
                          </ListItem>
                          <ListItem sx={{ display: "list-item" }}>
                              Або натисніть «Сканувати» і наведіть камеру на QR-код квитка
                          </ListItem>
                          <ListItem sx={{ display: "list-item" }}>
                              У разі успіху зʼявиться повідомлення з інформацією про квиток; якщо квиток вже скановано — з датою та часом сканування
                          </ListItem>
                      </List>
                  </CardContent>
              </Card>

        </Box>
    );
}

export default App;
